import React from 'react';
import { Link } from 'react-router-dom';
import Moment from 'react-moment';
import * as RT from '../../constants/Routing';
// import PlaceHolderImg from '../../assets/images/placeholder.png'
import PlaceHolderImg2x from '../../assets/images/placeholder@2x.png';
// import PlaceHolderImg2x from "../../assets/images/vert.jpg";
// import PlaceHolderImg2x from "../../assets/images/hori.png";
// import "moment-timezone";

export default class ResumeParticipantContent extends React.Component {
  constructor(props) {
    super(props);
    console.log(this.props.userData);

    this.taskData = this.props.taskData;
    console.log(this.taskData);
    this.currentDate = new Date();
    this.currentUser = JSON.parse(localStorage.getItem('current_user'));
    this.selfIntintroduction = this.props.userData.selfIntintroduction;
    this.limit = 400;
    if (this.selfIntintroduction && this.selfIntintroduction.length > this.limit) {
      this.selfIntintroduction = this.selfIntintroduction.substring(1, this.limit);
    }
  }

  _renderDate = () => {
    // 2&3: タスク予定日 YYYY/MM/DD 応募承認日 YYYY/MM/DD　出力日 YYYY/MM/DD hh:mm

    return `${this.props.task.startDate} ${this.props.task.startTime}-${this.props.task.endTime}`;
  };

  _renderImage = () => {
    if (!this.props.userData.photoId) {
      return <img className="img print_img" alt="" src={PlaceHolderImg2x} />;
    }
    return <img alt="" className="img print_img" src={this.props.userData.photoId} />;
  };

  _renderSex = () => {
    if (this.props.userData.sex == '女性') {
      return (
        <div className="row">
          <div className="col-6 center ">
            <div className="">
              <p>男</p>
            </div>
          </div>
          <div className="col-6 center">
            <div className="circle">
              <p>女</p>
            </div>
          </div>
        </div>
      );
    }
    if (this.props.userData.sex == '男性') {
      return (
        <div className="row">
          <div className="col-6 center ">
            <div className="circle">
              <p>男</p>
            </div>
          </div>
          <div className="col-6 center">
            <div className="">
              <p>女</p>
            </div>
          </div>
        </div>
      );
    }
    return (
      <div className="row">
        <div className="col-6 center ">
          <div className="">
            <p>男</p>
          </div>
        </div>
        <div className="col-6 center">
          <div className="">
            <p>女</p>
          </div>
        </div>
      </div>
    );
  };

  _renderDescription = () => {
    let desc = this.state.description;
    const descMaxSize = 200;
    if (!!desc && desc.length > descMaxSize) {
      desc = desc.slice(0, descMaxSize);
      desc += '...';
    }
    return desc;
  };

  _renderTaskTitle = () => {
    const { title } = this.taskData;
    const { taskId } = this.taskData;
    let value = '';
    if (taskId) {
      value = `<span className='taskid'>${taskId}</span>`;
    }
    if (title) {
      value = `${value}< span className = 'title' >${title}</span > `;
    }

    return (
      <span>
        <span className="taskid">{taskId}</span>
        <h3 className="title">{title}</h3>
      </span>
    );
  };

  _renderPhone = () => {
    let { phone } = this.props.userData;
    if (phone) {
      phone = phone.replace('+81', '0');
    }
    return phone;
  };

  _renderGraduation = () => {
    return (
      <div>
        <sapn>
          {this.props.userData.graduateYear}年{this.props.userData.graduateMonth}月卒業
        </sapn>
        <span className="graduation">{this.props.userData.graduation}</span>
      </div>
    );
  };

  render = () => {
    return (
      <div className="resume">
        <div className="part1">
          <div className="title p_tb_10">
            taskell 履歴書 <span className="b_name">({this.currentUser.enterpriseName})</span>
          </div>
          <div className="date p_tb_10 col-9">
            <Moment date={this.currentDate} tz="Asia/Tokyo" format="YYYY/MM/DD" />
          </div>
          <div className="subpart1 row">
            <div className="col-9">
              <div className="na_br_ge">
                <div className="div_kana row">
                  <div className="hirakana col-2 p_tb_10 center subtitle">フリガナ</div>
                  <div className="hira_value col-10 p_tb_10 ">
                    {this.props.userData.lastNameKana}
                    {'  '}
                    {this.props.userData.fastNameKana}
                  </div>
                </div>
                <div className="div_name row">
                  <div className="name col-2 p_tb_10 center subtitle">氏名</div>
                  <div className="name_value col-10 p_tb_10">
                    {this.props.userData.lastName}
                    {'  '}
                    {this.props.userData.fastName}
                  </div>
                </div>
                <div className="birth_sex row">
                  <div className="name col-2 p_tb_10 center subtitle">生年月日</div>
                  <div className="birth col-5 p_tb_10 ">
                    <p className="birth_value">
                      {this.props.userData.birthyear} 年{this.props.userData.birthmonth} 月
                      {this.props.userData.birthday} 日<span className="at">生</span>(
                      {this.props.userData.age}
                      歳)
                    </p>
                  </div>
                  <div className="name col-2 p_tb_10 center subtitle">性別</div>
                  <div className="sex col-3 p_tb_10">{this._renderSex()}</div>
                </div>
                <div className="phone_email row">
                  <div className="name col-2 p_tb_10 center subtitle">メール</div>
                  <div className="email col-5 p_tb_10 ">{this.props.userData.email}</div>
                  <div className="name col-2 p_tb_10 center subtitle">電話</div>
                  <div className="phone col-3 p_tb_10">{this._renderPhone()}</div>
                </div>
                <div className="address row">
                  <div className="name col-2 p_tb_10 center subtitle">現住所</div>
                  <div className="value col-10 p_tb_10 ">
                    {this.props.userData.postalcode}
                    <span>
                      {' '}
                      {this.props.userData.prefecture}
                      {this.props.userData.municipality}
                      {this.props.userData.street}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-3 photo">
              <div className="square">{this._renderImage()}</div>
            </div>
          </div>
        </div>
        <div className="part2-1 row">
          <div className="label col-12 p_tb_10 center subtitle">最終学歴</div>
          <div className="content col-12 p_tb_10">{this._renderGraduation()}</div>
        </div>
        <div className="part2 row">
          <div className="label col-12 p_tb_10 center subtitle">保有資格</div>
          <div className="content col-12 p_tb_10">
            <p>
              {(() => {
                if (
                  this.props.userData.licenseDetail &&
                  this.props.userData.licenseDetail.length > 0
                ) {
                  return this.props.userData.licenseDetail.map((license, i) => {
                    const last = i + 1 === this.props.userData.licenseDetail.length;
                    let text;
                    if (last) {
                      text = license.value;
                    } else {
                      text = `${license.value} /`;
                    }
                    return <span key={i}>{text}</span>;
                  });
                }
                return <span>-</span>;
              })()}
            </p>
          </div>
        </div>
        <div className="part2-3 row">
          <div className="label col-12 p_tb_10 center subtitle">タスク</div>
          <div className="content col-12 resume-task">
            <h2>タスクID:{this._renderTaskTitle()}</h2>
            <h4>
              タスク予定日: {this.taskData.startDate}
              <span>{this.taskData.workingHours}</span>
            </h4>
          </div>
        </div>
        <div className="part3 row">
          <div className="label col-12 p_tb_10 center subtitle">自己紹介／備考等</div>
          <div className="content col-12 p_tb_10">{this.selfIntintroduction}</div>
        </div>
        <div className="part4 row">
          <div className="col-12 p_tb_10">
            <p>
              本書は介護施設事業者がtaskellを通して募集した特定タスクへの応募者のプロフィール情報を利用して生成しています。応募者は簡易履歴書の生成利用に同意しています。本履歴書は介護事業者の便宜のために提供されるものであり、taskellはその内容の正確性については一切責任を負いかねますのでご了承ください。
            </p>
          </div>
        </div>
      </div>
    );
  };
}
